import InfoPage from '../StaticComponents/InfoPage/InfoPage';
import React from 'react';

const PAGE_NOT_FOUND = 'Page not found';

export const NotFound = () => <InfoPage header={PAGE_NOT_FOUND} />;
